import React, { useState, useEffect } from 'react'
import {
  Panel,
  InputNumber,
  Grid,
  Row,
  Col,
  Input,
  InputGroup,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  SelectPicker,
  IconButton,
  Icon,
  RadioGroup,
  Radio,
  Message,
  CheckboxGroup,
  Checkbox,
  Uploader,
  Modal,
  Button,
} from 'rsuite'
import {
  requiredFiled,
  isValidators,
  getMaxLengthData,
  isImageOrPdf,
} from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../../CustomIconMessageInfo'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import { downloadFileForm6 } from '../../../../redux/actions/background'
import { isEmpty } from 'lodash-es'
import NumberFormat from 'react-number-format'

export default function BackgroundOfRiskPointsForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
}) {
  const [frequentAccidentsPoint, setFrequentAccidentsPoint] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [schema, setSchema] = useState(_schema)
  const [riskPointSchema, setRiskPointSchema] = useState(_schema.riskPointSchema)
  // const riskPointSchema = schema.riskPointSchema

  useEffect(() => {
    let frequentAccidents = [..._schema.frequentAccidentsPointList.value]

    setValue(_schema.frequentAccidentsPointList.name, frequentAccidents)
    setSchema(_schema)
    setRiskPointSchema(_schema.riskPointSchema)
    setFrequentAccidentsPoint(frequentAccidents)
  }, [_schema])

  const onDownloadFile = async (fileId, fileName, accidentPointIndex, index) => {
    var file = await downloadFileForm6(projectId, fileId)
    var reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      // console.log(reader.result)
      let fileObj = {
        fileName: fileName,
        fileData: reader.result,
      }
      onRiskPointsFileChange(fileObj, accidentPointIndex, index)
    }
    reader.onerror = function (error) {
      console.log('Error: ', error)
    }
  }

  const onAddFrequentAccidentsPoint = () => {
    // console.log(frequentAccidentsPoint)

    var arr = [...frequentAccidentsPoint]

    var accidentsPoint = { riskPoints: [] }

    arr.push(accidentsPoint)

    setValue(schema.frequentAccidentsPointList.name, arr)
    setFrequentAccidentsPoint(arr)

    onAddRiskPoint(arr, arr.length - 1)
  }

  const onDeleteFrequentAccidentsPoint = (index) => {
    // console.log(frequentAccidentsPoint)

    var arr = [...frequentAccidentsPoint]

    arr.splice(index, 1)

    setValue(schema.frequentAccidentsPointList.name, arr)
    setFrequentAccidentsPoint(arr)
  }

  const onFrequentAccidentsPointChange = (name, value, index) => {
    let arr = [...frequentAccidentsPoint]

    arr[index][name] = value

    setValue(name + '_' + index, value)
    setValue(schema.frequentAccidentsPointList.name, arr)
    setFrequentAccidentsPoint(arr)
  }

  const onAddRiskPoint = (frequentAccidentsPoint, index) => {
    console.log('frequentAccidentsPoint', frequentAccidentsPoint)
    console.log('index', index)

    var arr = [...frequentAccidentsPoint]

    var riskPoint = arr[index].riskPoints ? [...arr[index].riskPoints] : []
    riskPoint.push({ point: '' })

    arr[index].riskPoints = riskPoint

    setValue(schema.frequentAccidentsPointList.name, arr)
    setFrequentAccidentsPoint(arr)
  }

  const onDeleteRiskPoint = (apIndex, index) => {
    // console.log(frequentAccidentsPoint)

    var arr = [...frequentAccidentsPoint]
    var riskPoint = [...arr[apIndex].riskPoints]

    riskPoint.splice(index, 1)
    arr[apIndex].riskPoints = riskPoint

    setValue(schema.frequentAccidentsPointList.name, arr)
    setFrequentAccidentsPoint(arr)
  }

  const onRiskPointsChange = (name, value, apIndex, index) => {
    let arr = [...frequentAccidentsPoint]

    // console.log('name, value, apIndex,index', name, value, apIndex, index)
    arr[apIndex].riskPoints[index][name] = value

    setValue(name + '_' + apIndex + '_' + index, value)
    setValue(schema.frequentAccidentsPointList.name, arr)
    setFrequentAccidentsPoint(arr)
  }

  const onRiskPointsFileChange = (fileObj, apIndex, index, isdelete) => {
    let arr = [...frequentAccidentsPoint]

    arr[apIndex].riskPoints[index]['fileName'] = fileObj.fileName
    arr[apIndex].riskPoints[index]['fileData'] = fileObj.fileData

    if (isdelete) {
      arr[apIndex].riskPoints[index]['fileUrl'] = ''
      arr[apIndex].riskPoints[index]['filePath'] = ''
    }

    // console.log('onRiskPointsFileChange arr', arr)
    setValue(schema.frequentAccidentsPointList.name, arr)
    setFrequentAccidentsPoint(arr)
  }

  const inputNumberGroup = (schemaObj, value, apIndex, index) => {
    const subName = '_' + apIndex + '_' + index
    // console.log('inputNumberGroup subName', subName)
    return (
      <Row>
        {errors[schemaObj.name + subName] && (
          <Col style={{ marginTop: 10 }}>
            <ErrorMessage error={errors[obj.name]} />
          </Col>
        )}
        <Col style={{ marginTop: 10 }}>
          <InputGroup>
            <InputGroup.Addon>
              <p>{schemaObj.preLabel}</p>
            </InputGroup.Addon>
            <Controller
              key={schemaObj.name + subName}
              name={schemaObj.name + subName}
              control={control}
              rules={isValidators(schemaObj.validators)}
              value={value}
              render={(props) => {
                return (
                  // <InputNumber
                  //   min={0}
                  //   disabled={schemaObj.disabled}
                  //   value={value}
                  //   placeholder={schemaObj.hint}
                  //   onChange={(value) => {
                  //     onRiskPointsChange(schemaObj.name, value, apIndex, index)
                  //   }}
                  // />
                  <NumberFormat
                    className="rs-input"
                    disabled={schemaObj.disabled}
                    thousandSeparator={true}
                    defaultValue={value}
                    placeholder={schemaObj.hint}
                    onValueChange={(e) => {
                      onRiskPointsChange(schemaObj.name, e.floatValue, apIndex, index)
                    }}
                  />
                )
              }}
            />
            <InputGroup.Addon>
              <p>{schemaObj.postLabel}</p>
            </InputGroup.Addon>
          </InputGroup>
        </Col>
      </Row>
    )
  }

  const renderRiskPointList = (riskPoints, accidentPointIndex) => {
    // console.log('riskPoints', riskPoints, accidentPointIndex)

    if (riskPoints) {
      return riskPoints.map((riskpoint, index) => {
        const subName = accidentPointIndex + '_' + index
        return (
          <div key={subName}>
            <Row>
              <Col>
                <ErrorMessage error={errors[riskPointSchema.point.name + '_' + subName]} />
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} style={{ width: 60 }}>
                <p style={{ marginTop: 5 }}>
                  {requiredFiled(
                    riskPointSchema.point.validators,
                    `${riskPointSchema.point.label} ${index + 1}`
                  )}
                  {/* {riskPointSchema.point.label} {index + 1} */}
                </p>
              </Col>
              <Col xs={22} sm={15} md={10} lg={8}>
                <Input
                  name={riskPointSchema.point.name + '_' + subName}
                  value={riskpoint.point}
                  inputRef={register(isValidators(riskPointSchema.point.validators))}
                  placeholder={riskPointSchema.point.hint}
                  onChange={(value) => {
                    onRiskPointsChange(riskPointSchema.point.name, value, accidentPointIndex, index)
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 0 }}>
                <p style={{ marginTop: 5 }}>
                  {requiredFiled(
                    riskPointSchema.driverBehavior.validators,
                    riskPointSchema.driverBehavior.label
                  )}
                </p>
                <ErrorMessage error={errors[riskPointSchema.driverBehavior.name + '_' + subName]} />
                <ErrorMessage
                  error={errors[riskPointSchema.otherDriverBehavior.name + '_' + subName]}
                />
                <Controller
                  key={riskPointSchema.driverBehavior.name + '_' + subName}
                  name={riskPointSchema.driverBehavior.name + '_' + subName}
                  control={control}
                  rules={isValidators(riskPointSchema.driverBehavior.validators)}
                  defaultValue={riskpoint.driverBehavior}
                  render={(props) => {
                    return (
                      <CheckboxGroup
                        value={riskpoint.driverBehavior}
                        onChange={(value) => {
                          onRiskPointsChange(
                            riskPointSchema.driverBehavior.name,
                            value,
                            accidentPointIndex,
                            index
                          )
                        }}
                      >
                        {riskPointSchema.driverBehavior.options.map((behavior) => {
                          return (
                            <Col xs={24} sm={24} md={8} lg={8}>
                              <Checkbox value={behavior.value}>
                                {behavior.label}
                                {riskpoint.driverBehavior &&
                                  riskpoint.driverBehavior.some((e) => e === 9) &&
                                  behavior.value === 9 && (
                                    <Input
                                      name={
                                        riskPointSchema.otherDriverBehavior.name + '_' + subName
                                      }
                                      value={riskpoint.otherDriverBehavior}
                                      inputRef={register(
                                        isValidators(riskPointSchema.otherDriverBehavior.validators)
                                      )}
                                      placeholder={riskPointSchema.otherDriverBehavior.hint}
                                      onChange={(value) => {
                                        onRiskPointsChange(
                                          riskPointSchema.otherDriverBehavior.name,
                                          value,
                                          accidentPointIndex,
                                          index
                                        )
                                      }}
                                    />
                                  )}
                              </Checkbox>
                            </Col>
                          )
                        })}
                      </CheckboxGroup>
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 5 }}>
                <CKEditorFrom
                  name={riskPointSchema.environment.name + '_' + subName}
                  schema={riskPointSchema.environment}
                  value={riskpoint.environment}
                  onChange={(value) => {
                    // console.log('value', value)
                    onRiskPointsChange(
                      riskPointSchema.environment.name,
                      value,
                      accidentPointIndex,
                      index
                    )
                  }}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                <p style={{ marginTop: 5 }}>
                  {requiredFiled(riskPointSchema.impact.validators, riskPointSchema.impact.label)}
                </p>
                <Row>
                  <Col xs={24} sm={12} md={8} lg={8}>
                    {inputNumberGroup(
                      riskPointSchema.numOfAccidents,
                      riskpoint.numOfAccidents,
                      accidentPointIndex,
                      index
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginRight: 10, width: 220 }}>
                    {inputNumberGroup(
                      riskPointSchema.died,
                      riskpoint.died,
                      accidentPointIndex,
                      index
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginRight: 10, width: 200 }}>
                    {inputNumberGroup(
                      riskPointSchema.diedMan,
                      riskpoint.diedMan,
                      accidentPointIndex,
                      index
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginRight: 10, width: 200 }}>
                    {inputNumberGroup(
                      riskPointSchema.diedWomen,
                      riskpoint.diedWomen,
                      accidentPointIndex,
                      index
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginRight: 10, width: 220 }}>
                    {inputNumberGroup(
                      riskPointSchema.injured,
                      riskpoint.injured,
                      accidentPointIndex,
                      index
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginRight: 10, width: 200 }}>
                    {inputNumberGroup(
                      riskPointSchema.injuredMan,
                      riskpoint.injuredMan,
                      accidentPointIndex,
                      index
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginRight: 10, width: 200 }}>
                    {inputNumberGroup(
                      riskPointSchema.injuredWomen,
                      riskpoint.injuredWomen,
                      accidentPointIndex,
                      index
                    )}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[riskPointSchema.fixRiskPoint.name + '_' + subName]} />
                <p style={{ marginTop: 10 }}>
                  {requiredFiled(
                    riskPointSchema.fixRiskPoint.validators,
                    riskPointSchema.fixRiskPoint.label
                  )}
                </p>
                <Row style={{ marginTop: 10, marginBottom: 10 }}>
                  <Controller
                    key={riskPointSchema.fixRiskPoint.name + '_' + subName}
                    name={riskPointSchema.fixRiskPoint.name + '_' + subName}
                    control={control}
                    rules={isValidators(riskPointSchema.fixRiskPoint.validators)}
                    defaultValue={riskpoint.fixRiskPoint}
                  />
                  <RadioGroup
                    inline
                    value={riskpoint.fixRiskPoint}
                    onChange={(value) => {
                      onRiskPointsChange(
                        riskPointSchema.fixRiskPoint.name,
                        value,
                        accidentPointIndex,
                        index
                      )
                    }}
                  >
                    {riskPointSchema.fixRiskPoint.options.map((fixRiskPoint) => {
                      return <Radio value={fixRiskPoint.value}>{fixRiskPoint.label}</Radio>
                    })}
                  </RadioGroup>

                  <Col style={{ marginLeft: 10 }}>
                    <CKEditorFrom
                      name={riskPointSchema.fixRiskPointDetail.name + '_' + subName}
                      schema={riskPointSchema.fixRiskPointDetail}
                      value={riskpoint.fixedRiskPointDetail}
                      onChange={(value) => {
                        onRiskPointsChange('fixedRiskPointDetail', value, accidentPointIndex, index)
                      }}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                </Row>
              </Col>

              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 0 }}>
                <p style={{ marginTop: 5 }}>
                  {requiredFiled(
                    riskPointSchema.attachFiles.validators,
                    riskPointSchema.attachFiles.label
                  )}
                </p>

                <Controller
                  key={`${riskPointSchema.attachFiles.name}_${accidentPointIndex}_${index}`}
                  name={`${riskPointSchema.attachFiles.name}_${accidentPointIndex}_${index}`}
                  control={control}
                  rules={isValidators(riskPointSchema.attachFiles.validators)}
                  defaultValue={''}
                  render={(props) => {
                    return (
                      <Uploader
                        autoUpload={false}
                        disabled={riskPointSchema.attachFiles.disabled}
                        fileListVisible={false}
                        // listType="picture-text"
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            let fileObj = {
                              fileName: '',
                              fileData: '',
                            }
                            onRiskPointsFileChange(fileObj, accidentPointIndex, index, false)
                            props.onChange(undefined)
                          } else {
                            let files = []
                            let file = fileList[fileList.length - 1]
                            if (isImageOrPdf(file.blobFile.type)) {
                              var reader = new FileReader()
                              reader.readAsDataURL(file.blobFile)
                              reader.onload = function () {
                                // console.log(reader.result)
                                let fileObj = {
                                  fileName: file.name,
                                  fileData: reader.result,
                                }
                                onRiskPointsFileChange(fileObj, accidentPointIndex, index, false)
                              }
                              reader.onerror = function (error) {
                                console.log('Error: ', error)
                              }

                              files.push(file)
                              props.onChange(files)
                            } else {
                              setFileTypeError(true)
                            }
                          }
                        }}
                        draggable
                      >
                        <div style={{ lineHeight: '100px' }}>
                          <Icon size="2x" icon="image" />
                          <small
                            style={{
                              marginTop: '-70px',
                              display: 'block',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            คลิกหรือลากไฟล์มายังพื้นที่นี้
                          </small>
                        </div>
                      </Uploader>
                    )
                  }}
                />

                {(riskpoint.fileData || riskpoint.fileUrl) && (
                  <Row style={{ marginTop: 10 }}>
                    <div style={{ width: '100%', textAlign: 'center' }}>
                      <img
                        src={riskpoint.fileData || riskpoint.fileUrl}
                        style={{ width: 'auto', height: '150px' }}
                      ></img>
                      <div style={{ marginTop: 10 }}>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={
                            <Icon
                              appearance="ghost"
                              icon="trash"
                              className="bt-gost-icon-radius-cancel"
                            />
                          }
                          onClick={() => {
                            let fileObj = {
                              fileName: '',
                              fileData: '',
                            }
                            onRiskPointsFileChange(fileObj, accidentPointIndex, index, true)
                          }}
                        >
                          ลบภาพ
                        </IconButton>
                      </div>
                    </div>
                  </Row>
                )}
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <IconButton
                appearance="ghost"
                className="rs-btn-ghost-cancel"
                icon={
                  <Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />
                }
                onClick={() => onDeleteRiskPoint(accidentPointIndex, index)}
              >
                ลบจุดเกิดอุบัติเหตุ
              </IconButton>
            </Row>
            {riskPoints?.length - 1 == index && (
              <Row style={{ marginTop: 10 }}>
                <IconButton
                  appearance="ghost"
                  icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                  onClick={(e) => onAddRiskPoint(frequentAccidentsPoint, accidentPointIndex)}
                  style={{ marginRight: 10 }}
                >
                  เพิ่มจุดเกิดอุบัติเหตุ
                </IconButton>
              </Row>
            )}

            <hr />
          </div>
        )
      })
    }
  }

  const renderFrequentAccidentsPoint = frequentAccidentsPoint.map((item, index) => {
    // console.log('frequentAccidentsPoint item', item)
    return (
      <div key={index}>
        <Form layout="inline">
          <FormGroup style={{ marginBottom: 5, width: '100%' }}>
            <Row>
              <ErrorMessage error={errors[schema.accidentPoint.name + '_' + index]} />
              <ErrorMessage error={errors[schema.otherAccidentPoint.name + '_' + index]} />
              <ControlLabel>{schema.accidentPoint.label} &nbsp; </ControlLabel>
              <Controller
                key={schema.accidentPoint.name + '_' + index}
                name={schema.accidentPoint.name + '_' + index}
                control={control}
                rules={isValidators(schema.accidentPoint.validators)}
                defaultValue={item.accidentPoint}
                render={() => {
                  return (
                    <SelectPicker
                      searchable={false}
                      defaultValue={item.accidentPoint}
                      data={schema.accidentPoint.options}
                      placeholder={schema.accidentPoint.hint || 'กรุณาเลือก'}
                      onChange={(value) => {
                        onFrequentAccidentsPointChange(schema.accidentPoint.name, value, index)
                      }}
                    />
                  )
                }}
              />
              {item.accidentPoint == 9 && (
                <>
                  <ControlLabel>&nbsp;{schema.otherAccidentPoint.label}</ControlLabel>

                  <Controller
                    key={schema.otherAccidentPoint.name + '_' + index}
                    name={schema.otherAccidentPoint.name + '_' + index}
                    control={control}
                    rules={isValidators(schema.otherAccidentPoint.validators)}
                    defaultValue={item.otherAccidentPoint}
                    render={() => {
                      return (
                        <FormControl
                          style={{ width: 170 }}
                          value={item.otherAccidentPoint}
                          placeholder={schema.otherAccidentPoint.hint}
                          onChange={(value) => {
                            onFrequentAccidentsPointChange(
                              schema.otherAccidentPoint.name,
                              value,
                              index
                            )
                          }}
                        />
                      )
                    }}
                  />
                </>
              )}
            </Row>

            <Panel bordered style={{ marginTop: 10 }}>
              <Row style={{ marginTop: 10 }}>{renderRiskPointList(item.riskPoints, index)}</Row>
              {item.riskPoints?.length < 1 && (
                <>
                  <Row style={{ marginTop: 10 }}>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                      onClick={(e) => onAddRiskPoint(frequentAccidentsPoint, index)}
                      style={{ marginRight: 10 }}
                    >
                      เพิ่มจุดเกิดอุบัติเหตุ
                    </IconButton>
                  </Row>
                  <hr />
                </>
              )}

              <Row style={{ marginTop: 10 }}>
                <IconButton
                  appearance="ghost"
                  className="rs-btn-ghost-cancel"
                  icon={
                    <Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />
                  }
                  onClick={() => onDeleteFrequentAccidentsPoint(index)}
                >
                  ลบบริเวณจุดที่เกิดอุบัติเหตุบ่อย
                </IconButton>
              </Row>
            </Panel>
          </FormGroup>
        </Form>
        <hr />
      </div>
    )
  })

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            <p>
              <b>{schema.accidentProblem.label}</b>
            </p>
            <Message
              style={{ fontSize: '1rem' }}
              type={schema.accidentProblem.type || 'info'}
              showIcon
              description={schema.accidentProblem.message}
            />
          </Row>
          <Row>
            <CKEditorFrom
              schema={schema.communityInfo}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Row>

          <Row style={{ marginTop: 10 }}>
            <p>{schema.accidentProblemDetail.label}</p>
            {/* <CustomIconMessageInfo contents={schema.activityList.description} /> */}
            <Row style={{ marginLeft: 10 }}>
              <Form layout="inline" style={{ marginTop: 10 }}>
                <FormGroup>
                  <ErrorMessage error={errors[schema.accidentRiskPoint.name]} />
                  <ControlLabel>
                    {requiredFiled(
                      schema.accidentRiskPoint.validators,
                      schema.accidentRiskPoint.label
                    )}
                  </ControlLabel>
                  <Controller
                    key={schema.accidentRiskPoint.name}
                    name={schema.accidentRiskPoint.name}
                    control={control}
                    rules={isValidators(schema.accidentRiskPoint.validators)}
                    defaultValue={schema.accidentRiskPoint.value}
                    render={(props) => {
                      return (
                        <FormControl
                          style={{ width: 110 }}
                          value={props.value}
                          placeholder={schema.accidentRiskPoint.hint}
                          onChange={(value) => {
                            setValue(schema.accidentRiskPoint.name, value)
                            clearErrors(schema.accidentRiskPoint.name)
                          }}
                        />
                      )
                    }}
                  />

                  <ControlLabel style={{ marginLeft: 10 }}>
                    {schema.accidentRiskPoint.postLabel}
                  </ControlLabel>
                </FormGroup>
              </Form>

              <Col>{schema.frequentAccidentsPointList.label}</Col>
              <Col>
                <CustomIconMessageInfo contents={schema.frequentAccidentsPointList.description} />
              </Col>

              <Row style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.frequentAccidentsPointList.name]} />
                <Controller
                  key={schema.frequentAccidentsPointList.name}
                  name={schema.frequentAccidentsPointList.name}
                  control={control}
                  rules={isValidators(schema.frequentAccidentsPointList.validators)}
                  defaultValue={frequentAccidentsPoint}
                />
                {renderFrequentAccidentsPoint}
              </Row>

              <Row>
                <Col>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                    onClick={() => onAddFrequentAccidentsPoint()}
                    style={{ marginRight: 5 }}
                  >
                    เพิ่มบริเวณจุดที่เกิดอุบัติเหตุบ่อย
                  </IconButton>
                </Col>
              </Row>

              <Col style={{ marginTop: 10 }}>
                <CKEditorFrom
                  schema={schema.loss}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            </Row>
          </Row>
        </Grid>
      </Panel>

      <Modal
        backdrop="static"
        size="xs"
        show={fileTypeError}
        onHide={() => {
          setFileTypeError(false)
        }}
      >
        <div style={{ width: '100%', textAlign: 'center', marginTop: 10 }}>
          <p style={{ color: 'red' }}>อัพโหลดไฟล์เป็นรูปภาพเท่านั้น</p>
          <p>
            <i>* ชนิดที่รองรับ png , jpeg , jpg</i>
          </p>
          <Button
            style={{ marginTop: 20 }}
            onClick={() => {
              setFileTypeError(false)
            }}
            ripple
            appearance="ghost"
          >
            ปิด
          </Button>
        </div>
      </Modal>
    </>
  )
}
